import { JSM_BASE_URL } from '../settings';
import {
  type BlockFormData,
  type FieldSettings,
  type FieldValue,
  type FormSettings,
  type JsmErrorResponseDto,
  type JsmRequestDto,
  type JsmRequestFieldDto,
} from '../types';
import { JsmClient } from '../utilities';
import { mapJsmErrorResponseDtoToFormError } from './mapJsmErrorResponseDtoToFormError';

export const createJsmRequest = async (
  formData: BlockFormData | undefined,
  formSettings: FormSettings,
  dataKey: string,
): Promise<undefined> => {
  const jsmClient = new JsmClient(JSM_BASE_URL);
  const url = `${encodeURIComponent(dataKey)}/request?requestTypeId=${encodeURIComponent(
    formSettings.config.requestTypeId,
  )}`;
  const body = mapBlockFormDataToJsmRequestDto(formData, formSettings);

  try {
    console.debug('createJsmRequest: JSM-request body:', body);
    // on http 200 the response is undefined
    return await jsmClient.post(url, body);
  } catch (error: any) {
    console.error('createJsmRequest: JSM error:', JSON.parse(JSON.stringify(error)));
    const jsmError = error.responseBody as JsmErrorResponseDto;
    throw mapJsmErrorResponseDtoToFormError(jsmError);
  }
};

const mapBlockFormDataToJsmRequestDto = (
  formData: BlockFormData | undefined,
  formSettings: FormSettings,
): JsmRequestDto => {
  const fields = formSettings.fields.map((fieldSettings: FieldSettings): JsmRequestFieldDto | undefined => {
    let value: any =
      formData && formData[fieldSettings.name] !== undefined
        ? formData[fieldSettings.name]
        : fieldSettings.defaultValue;

    switch (fieldSettings.type) {
      case 'select':
      case 'radio': {
        // not mandatory select and radio fields can be skipped in request
        if (!fieldSettings.required && value === undefined) {
          return undefined;
        }
        value = value !== undefined ? { id: String(value) } : {};
        break;
      }
      case 'checkbox-group': {
        value = value.map((v: FieldValue) => {
          return { id: String(v) };
        });
        break;
      }
      case 'file': {
        value = value !== undefined ? value.map((v: FieldValue) => String(v)) : [];
        break;
      }
      case 'date': {
        // empty date field does not trigger any error on the server, but the whole ticket won't be created, so better skip it
        if (value === undefined || value === '') {
          return undefined;
        }
        value = String(value);
        break;
      }
      default:
        value = value !== undefined ? String(value) : '';
    }

    return {
      id: fieldSettings.name,
      value,
    };
  });

  return { fields: fields.filter(v => v !== undefined) };
};
